var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"navbar_btn",class:{ button__loading: _vm.isLoading, shaked: _vm.shaked },attrs:{"disabled":_vm.isDisabled || _vm.isLoading,"type":_vm.type},on:{"click":function($event){return _vm.$emit('onClick')}}},[_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }